var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRakennusliittoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.6 192.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff4632;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.5,0L0,63.5v129.1h129.1l63.5-63.5V0H63.5ZM67,21.2l37.2,37.2H29.8l37.2-37.2h0ZM17.5,75.9h40.8v46l-40.8,40.8v-86.8ZM116.6,175.1H29.8l40.8-40.8h46v40.8h0ZM116.6,116.7h-40.8v-40.8h40.8v40.8h0ZM125.5,54.7l-37.2-37.2h74.4l-37.2,37.2h0ZM175,121.9l-40.8,40.8v-91.9l40.8-40.8v91.9h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRakennusliittoLogo);
export default __webpack_public_path__ + "static/media/rakennusliitto-logo.0adbf83a5fd4db878506aa9e1efc8d23.svg";
export { ForwardRef as ReactComponent };